/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerHatchery } from '../../models/customer-hatchery';

export interface FindByBusinessNumber_1$Params {
  businessNumber: string;
  zipCode: string;
}

export function findByBusinessNumber_1(http: HttpClient, rootUrl: string, params: FindByBusinessNumber_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerHatchery>>> {
  const rb = new RequestBuilder(rootUrl, findByBusinessNumber_1.PATH, 'get');
  if (params) {
    rb.path('businessNumber', params.businessNumber, {});
    rb.path('zipCode', params.zipCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerHatchery>>;
    })
  );
}

findByBusinessNumber_1.PATH = '/api/customer/hatchery/businessNumber/{businessNumber}/zipCode/{zipCode}';
